import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { InputNumber } from 'ngx-weui/core';
import { Observable } from 'rxjs';

/**
 * 获取验证码
 */
@Directive({
  selector: '[weui-vcode]',
  exportAs: 'weuiVcode',
  host: {
    '(click)': '_onClick()',
    '[disabled]': '_disabled',
  },
})
export class VCodeDirective implements OnInit, OnDestroy {
  /**
   * 发送事件
   */
  @Input('weui-vcode') onSend: () => Observable<boolean>;

  /**
   * 时长（单位：秒），默认：`60`
   */
  @Input('weui-seconds') @InputNumber() seconds: number = 60;

  /**
   * 倒计时模板，使用 `${num}` 表示当前秒数
   */
  // tslint:disable-next-line: no-invalid-template-strings
  @Input('weui-tpl') tpl: string = '${num} 秒';

  /**
   * 重新发送提醒文本
   */
  @Input('weui-error') error: string = '重新发送';

  _disabled: boolean = false;
  private _cur: string;
  private _t: any;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    if (typeof this.onSend !== 'function') {
      console.error('weui-vcode必须传递一个返回值为 `Observable<boolean>` 函数');
    }
    this._cur = this.el.nativeElement.innerHTML;
  }

  _onClick(): void {
    this._disabled = true;
    this.onSend().subscribe(res => {
      res ? this.tick() : this.err();
    });
  }

  private err(): void {
    this._disabled = false;
    this.el.nativeElement.innerHTML = this.error;
  }

  private tick(): void {
    let count = this.seconds < 1 ? 1 : this.seconds;
    this.setText(count);
    this._t = setInterval(() => {
      if (--count <= 0) {
        this._disabled = false;
        this.el.nativeElement.innerHTML = this._cur;
        this.destroy();
      } else {
        this.setText(count);
      }
    }, 1000);
  }

  private setText(num: number): void {
    this.el.nativeElement.innerHTML = this.tpl.replace(/\${num}/, num.toString());
  }

  private destroy(): void {
    if (this._t) {
      clearInterval(this._t);
      this._t = null;
    }
  }

  ngOnDestroy(): void {
    this.destroy();
  }
}
